// useDisableScrolling.js
import { useEffect } from 'react';

const useDisableScrolling = (isActive) => {
  useEffect(() => {
    const roots = [document.body, document.documentElement];

    if (isActive) {
      // Lock only the root scrollbars
      roots.forEach((el) => {
        el.style.overflow = 'hidden';
        el.style.overscrollBehavior = 'none';
      });
    } else {
      // Restore
      roots.forEach((el) => {
        el.style.overflow = '';
        el.style.overscrollBehavior = '';
      });
    }

    return () => {
      roots.forEach((el) => {
        el.style.overflow = '';
        el.style.overscrollBehavior = '';
      });
    };
  }, [isActive]);
};

export default useDisableScrolling;